import React, { useEffect, useState } from "react";
import { getMyUpcomingShifts } from "../../api/attendance";
import "./HomeUpcomingShifts.css";

const SHIFT_LABELS = {
  MORNING: "صباحي",
  EVENING: "مسائي",
  BOTH: "صباحي ومسائي",
  NIGHT: "ليلي",
  INVENTORY: "جرد",
};

function formatRange(start, end) {
  if (!start && !end) return null;
  if (start && end) return `${start} — ${end}`;
  return start || end;
}

function UpcomingShiftCard({ day }) {
  const range = formatRange(day.startTime, day.endTime);
  const shiftLabel = day.shift ? SHIFT_LABELS[day.shift] || day.shift : null;
  const isOff = day.dayType === "REST" || day.dayType === "LEAVE";
  const noTimesheet = !day.hasTimesheet && day.source === "policy";

  return (
    <article
      className={`ess-upcoming-shift-card${noTimesheet ? " is-no-timesheet" : ""}${isOff ? " is-off" : ""}`}
    >
      <div className="ess-upcoming-shift-top">
        <h3 className="ess-upcoming-shift-label">{day.label}</h3>
        <span className="ess-upcoming-shift-date">{day.date}</span>
      </div>
      {day.message ? (
        <p className="ess-upcoming-shift-note">{day.message}</p>
      ) : null}
      {range ? (
        <dl className="ess-upcoming-shift-meta">
          <div>
            <dt>من</dt>
            <dd>{day.startTime || "—"}</dd>
          </div>
          <div>
            <dt>إلى</dt>
            <dd>{day.endTime || "—"}</dd>
          </div>
          {shiftLabel ? (
            <div>
              <dt>الشيفت</dt>
              <dd>{shiftLabel}</dd>
            </div>
          ) : null}
        </dl>
      ) : null}
    </article>
  );
}

export default function HomeUpcomingShifts() {
  const [days, setDays] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getMyUpcomingShifts()
      .then((data) => {
        if (cancelled) return;
        setDays(Array.isArray(data?.days) ? data.days : []);
        setError(null);
      })
      .catch(() => {
        if (!cancelled) {
          setDays([]);
          setError("تعذر تحميل مواعيد الشيفت");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return (
      <section className="ess-table-card ess-home-shifts-section" dir="rtl">
        <div className="ess-home-section-head">
          <h2 className="ess-table-title">شيفتاتك الجاية</h2>
          <p className="ess-home-section-sub">جاري التحميل…</p>
        </div>
      </section>
    );
  }

  if (error || !days.length) {
    return null;
  }

  return (
    <section className="ess-table-card ess-home-shifts-section" dir="rtl">
      <div className="ess-home-section-head">
        <h2 className="ess-table-title">شيفتاتك الجاية</h2>
        <p className="ess-home-section-sub">
          مواعيد غداً وبعد غد حسب التايم شيت
        </p>
      </div>
      <div className="ess-upcoming-shift-list">
        {days.map((day) => (
          <UpcomingShiftCard key={day.date} day={day} />
        ))}
      </div>
    </section>
  );
}
